/* @flow weak */
export default function focusNode(node) {
  // IE throws an error when trying to focus a node for various reasons.
  // It's easier to just try/catch it and not deal with it ourselves.
  try {
    node.focus();
  } catch (e) {
    // Do nothing.
  }
}
